/**
 * Client and server environment configuration for iMarket Admin console.
 * Strictly avoids embedding secrets or private credentials.
 */
export const env = {
  apiBaseUrl: process.env.NEXT_PUBLIC_ADMIN_API_URL || process.env.NEXT_PUBLIC_ADMIN_API_BASE_URL || 'http://localhost:5000',
  environmentName: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0-dev',
} as const;

